module.exports = __webpack_public_path__ + "static/media/morty.77e47449.png";